import React, { useContext, useEffect, useRef, useState } from 'react';
import styles from './CollapseVacancy.module.scss';
import StatesContext from '../../context/states';

const CollapseVacancy = (props) => {
  const { count, toggler, align, data, size, filterType } = props;
  const states = useContext(StatesContext);
  const { filterCollapses, updateFilterCollapses } = states;
  const [isShown, setShown] = useState(false);
  const [isInit, setInit] = useState(false);
  const [currentOpenedCollapse, setCurrentOpenedCollapse] = useState(null);
  const refWrap = useRef(null);
  const refHidden = useRef(null);
  const refInner = useRef(null);
  let shownItems = [];
  let hiddenItems = [];
  let wrapClass = `${styles.wrap}`;

  useEffect(() => {
    const wrap = refWrap.current;
    const hidden = refHidden.current;
    const inner = refInner.current;
    if (isShown) {
      wrap.classList.add(styles.active);
      if (inner !== null && hidden !== null) {
        hidden.style.height = `${inner.offsetHeight + 1}px`;
      }
    } else {
      wrap.classList.remove(styles.active);
      if (inner !== null && hidden !== null) {
        hidden.style.height = ``;
      }
    }
  }, [isShown]);
  useEffect(() => {
    if (isInit) return;
    setInit(true);
    if (size === 'small') {
      let status = 'close';
      if (count !== null && data.length <= count + 1) {
        status = 'disable';
      }
      updateFilterCollapses((prev) => {
        let obj = { ...prev };
        obj[filterType] = status;
        return obj;
      });
    }
  }, [count, data, filterType, isInit, size, updateFilterCollapses]);
  data.forEach((element, index) => {
    if (count === null || data.length <= count + 1) {
      shownItems.push(element);
    } else if (count !== null && index <= count - 1) {
      shownItems.push(element);
    } else {
      hiddenItems.push(element);
    }
  });
  if (size !== undefined && styles[`wrap_${size}`] !== undefined) {
    wrapClass += ` ${styles[`wrap_${size}`]}`;
  }
  if (align !== undefined && styles[`wrap_${align}`] !== undefined) {
    wrapClass += ` ${styles[`wrap_${align}`]}`;
  }
  const toggleCollapse = () => {
    setShown(!isShown);
    if (size === 'small') {
      let status = 'open';
      if (isShown) {
        status = 'close';
      }
      if (count !== null && data.length > count + 1) {
        updateFilterCollapses((prev) => {
          let obj = { ...prev };
          obj[filterType] = status;
          return obj;
        });
      }
    }
  };

  return (
    <>
      <div className={wrapClass} ref={refWrap}>
        <div className={styles.wrapper}>
          <div className={styles.shown}>{shownItems}</div>
          {count !== null && data.length > count + 1 ? (
            <div className={styles.hidden} ref={refHidden}>
              <div className={styles.inner} ref={refInner}>
                {hiddenItems}
              </div>
            </div>
          ) : null}
        </div>
        {count !== null && data.length > count + 1 ? (
          <div className={styles.toggler} onClick={toggleCollapse}>
            {isShown ? 'Свернуть' : toggler}
            <svg
              width="14"
              height="7"
              viewBox="0 0 14 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1 1L7 6L13 1" stroke="#008359" />
            </svg>
          </div>
        ) : size === 'big' ? (
          <div className={styles.spacer}></div>
        ) : null}
      </div>
    </>
  );
};

export default CollapseVacancy;
